import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { SearchPagesPageNameComponent } from './search-pages-page-name.component';

@NgModule({
  imports: [CommonModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SearchLiteraturesPageName: {
          component: SearchPagesPageNameComponent,
        },
      },
    }),
  ],
})
export class SearchLiteraturesPageNameModule {}
